import { render, staticRenderFns } from "./ImeiAssignment.vue?vue&type=template&id=47cfb02e&"
import script from "./ImeiAssignment.vue?vue&type=script&lang=js&"
export * from "./ImeiAssignment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports